import Navbar from "./components/Navbar/Navbar";
import "./stylesheets/index.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import HomePage from "./pages";
import ProjectsPage from "./pages/projects";
import ContactPage from "./pages/contact";
import UnderConstructionPage from "./pages/underConstruction";

export default function App() {
  return (
    <Router>
      <Navbar />
      <Routes>
        <Route exact path="/" element={<HomePage />} />
        <Route exact path="/projects" element={<ProjectsPage />} />
        <Route exact path="/contact" element={<ContactPage />} />
        <Route
          exact
          path="/under-construction"
          element={<UnderConstructionPage />}
        />
      </Routes>
    </Router>
  );
}
